import { CartAddEvent } from './events.js';

/**
 * Teeinblue Integration for Horizon Theme
 * Bridges Teeinblue's Shopify.onItemAdded callback to Horizon's CartAddEvent
 */
class TeeinblueCartIntegration {
  constructor() {
    this.init();
  }

  init() {
    console.log('[Teeinblue Integration] Initializing...');
    
    // Store reference to any existing onItemAdded callback
    const originalOnItemAdded = window.Shopify?.onItemAdded;
    
    // Ensure Shopify object exists
    window.Shopify = window.Shopify || {};
    
    // Override Shopify.onItemAdded to intercept Teeinblue's callback
    window.Shopify.onItemAdded = (lineItem) => {
      console.log('[Teeinblue Integration] Item added:', lineItem);
      
      // Call original callback if it exists
      if (typeof originalOnItemAdded === 'function') {
        try {
          originalOnItemAdded(lineItem);
        } catch (error) {
          console.warn('[Teeinblue Integration] Error in original onItemAdded:', error);
        }
      }
      
      // Dispatch CartAddEvent that Horizon theme listens for
      this.dispatchCartAddEvent(lineItem);
    };
    
    console.log('[Teeinblue Integration] Ready');
  }

  dispatchCartAddEvent(lineItem) {
    try {
      // Create the CartAddEvent with the line item data
      const event = new CartAddEvent(
        { items: [lineItem] }, // resource
        'teeinblue-form', // sourceId
        {
          source: 'teeinblue',
          variantId: lineItem.variant_id,
          productId: lineItem.product_id,
        }
      );
      
      document.dispatchEvent(event);
      console.log('[Teeinblue Integration] CartAddEvent dispatched successfully');
    } catch (error) {
      console.error('[Teeinblue Integration] Error dispatching CartAddEvent:', error);
      
      // Fallback: manually open cart drawer
      this.manuallyOpenCartDrawer();
    }
  }

  manuallyOpenCartDrawer() {
    console.log('[Teeinblue Integration] Attempting manual cart drawer open...');
    
    setTimeout(() => {
      const cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
        console.log('[Teeinblue Integration] Cart drawer opened manually');
      } else {
        console.warn('[Teeinblue Integration] Could not find cart drawer component');
      }
    }, 300);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new TeeinblueCartIntegration();
  });
} else {
  new TeeinblueCartIntegration();
}